export default {

    getFleetOperationStatus: {
        method: 'get',
        url: '/client/dashboard/fleet-operation/fleet-operation-status'
    },
    getDataFleetOperationStatus: {
        method: 'get',
        url: '/client/dashboard/fleet-operation/data-fleet-operation-status?type=TYPE'
    },

    getVehicleShipingStatus: {
        method: 'get',
        url: '/client/dashboard/fleet-operation/vehicle-shiping-status'
    },
    getDataVehicleShipingStatus: {
        method: 'get',
        url: '/client/dashboard/fleet-operation/data-vehicle-shiping-status?type=TYPE'
    }
}
